import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from './AuthContext';
import { useCan } from './useCan';

/** Inline gate: render children only if the user has `cap`, else `fallback`. */
export function RequirePermission({
  cap,
  children,
  fallback = null,
}: {
  cap: string;
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const can = useCan();
  return <>{can(cap) ? children : fallback}</>;
}

/** Route guard: redirect to /login if unauthenticated, to / if lacking `cap`. */
export function ProtectedRoute({ cap, children }: { cap: string; children: ReactNode }) {
  const { user, loading } = useAuth();
  const can = useCan();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!can(cap)) return <Navigate to="/" replace />;
  return <>{children}</>;
}
